/**
 * Teacher Service - API client for the teacher dashboard overview
 */
import api from '../utils/api';

const teacherService = {
  getDashboard: async (termId) => {
    try {
      return await api.get('/api/teacher/dashboard', { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching teacher dashboard:', error);
      throw error;
    }
  },

  getQuickStats: async (termId) => {
    try {
      return await api.get('/api/teacher/dashboard/quick-stats', { params: { term_id: termId } });
    } catch (error) {
      console.error('Error fetching teacher dashboard quick stats:', error);
      throw error;
    }
  }
};

export default teacherService;
